var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJakeHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29392",
    "data-name": "Group 29392",
    transform: "translate(-153.999 -342.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(153.999 342.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-jake",
    transform: "translate(172.705 352.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50146",
    "data-name": "Path 50146",
    d: "M19.629,12.033c0,.781,0,2.735-1.172,2.735a1.652,1.652,0,0,1-1.172-.391v5.861H6.344V14.377a1.652,1.652,0,0,1-1.172.391C4.017,14.768,4,12.815,4,12.033A7.446,7.446,0,0,1,11.814,5,7.446,7.446,0,0,1,19.629,12.033Z",
    transform: "translate(-4 -5)",
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50147",
    "data-name": "Path 50147",
    d: "M22.689,24s-.281,1.977-1.567,2.567l-.023.012c-.012,0-.023.012-.035.016a.564.564,0,0,0,.063-.25c0-.43-.524-.781-1.172-.781a1.273,1.273,0,0,0-1.074.473,1.2,1.2,0,0,1-.113-.133A4.751,4.751,0,0,1,18,24a4.388,4.388,0,0,0,2.344.781A4.388,4.388,0,0,0,22.689,24Z",
    transform: "translate(-12.53 -16.576)",
    fill: "#821616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50148",
    "data-name": "Path 50148",
    d: "M22.5,28.781a.564.564,0,0,1-.063.25,1.916,1.916,0,0,1-.719.141,1.865,1.865,0,0,1-1.4-.625.571.571,0,0,1-.063-.074A1.273,1.273,0,0,1,21.324,28C21.973,28,22.5,28.352,22.5,28.781Z",
    transform: "translate(-13.901 -19.013)",
    fill: "#e57373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50149",
    "data-name": "Path 50149",
    d: "M20.285,29.391v5.47H19.112V29A1.652,1.652,0,0,0,20.285,29.391ZM8.172,29v5.861H7v-5.47A1.651,1.651,0,0,0,8.172,29Z",
    transform: "translate(-5.828 -19.623)",
    fill: "#f9a825"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50150",
    "data-name": "Path 50150",
    d: "M17.907,16.01c-4.478.109-4.082,3.935-3.674,5.076.249.692.767,1.172,1.225,1.172,1.225,0,1.437-1.985,1.633-3.126a.823.823,0,0,1,1.632,0c.2,1.141.408,3.126,1.633,3.126.457,0,.976-.481,1.225-1.172C21.989,19.945,22.385,16.119,17.907,16.01Z",
    transform: "translate(-10.093 -11.708)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28949",
    "data-name": "Group 28949",
    transform: "translate(2.735 2.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50151",
    "data-name": "Path 50151",
    d: "M13.165,14.675a3.036,3.036,0,0,0-.793,1.262,1.954,1.954,0,0,1,.055-3.747,1.7,1.7,0,0,0-.254.9A1.746,1.746,0,0,0,13.165,14.675Zm7.99-.508a1.949,1.949,0,0,1-1.368,1.77,3.154,3.154,0,0,0-2.516-2.118,1.947,1.947,0,0,1,1.211-1.567,1.707,1.707,0,0,0-.059.449,1.756,1.756,0,0,0,1.758,1.758A1.731,1.731,0,0,0,21.155,14.167Zm-5.075,1.074c-.863,0-1.563.35-1.563.781s.7.781,1.563.781,1.563-.35,1.563-.781S16.943,15.242,16.079,15.242Z",
    transform: "translate(-11 -12.19)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28950",
    "data-name": "Group 28950",
    transform: "translate(3.907 2.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50152",
    "data-name": "Path 50152",
    d: "M16.716,13.7a3.543,3.543,0,0,0-1.723.856A1.746,1.746,0,0,1,14,12.977a1.7,1.7,0,0,1,.254-.9A1.812,1.812,0,0,1,14.781,12,1.95,1.95,0,0,1,16.716,13.7Zm6.271.25a.817.817,0,0,1,0,.1,1.731,1.731,0,0,1-.973.293,1.756,1.756,0,0,1-1.758-1.758,1.707,1.707,0,0,1,.059-.449A2.015,2.015,0,0,1,21.033,12,1.954,1.954,0,0,1,22.987,13.954Z",
    transform: "translate(-14 -12)",
    fill: "#fafafa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJakeHighlighted);
export default __webpack_public_path__ + "static/media/jakeHighlighted.fd16b41d7f3b3862e9b62af80291a4b3.svg";
export { ForwardRef as ReactComponent };